import { pdsTv } from '@nestle-npus-nbm/pds-ui';
import * as React from 'react';
import { sortWithNewProductFirst } from 'src/utils/helpers';

interface IProductStatusListProps {
  statuses: IFieldProductStatus[];
  title?: string;
}

const prdStatus = pdsTv({
  slots: {
    wrapper: 'pds-rounded-sm pds-px-2 pds-py-1',
    text: 'pds-hyphens-auto pds-break-words pds-text-body-sm pds-font-bold pds-uppercase',
  },
  variants: {
    theme: {
      info: { wrapper: 'pds-bg-info-tonal', text: 'pds-text-info' },
      success: { wrapper: 'pds-bg-success-tonal', text: 'pds-text-success' },
      warning: { wrapper: 'pds-bg-purple-tonal', text: 'pds-text-purple-base' },
      error: { wrapper: 'pds-bg-error-tonal', text: 'pds-text-error' },
    },
  },
});

const ProductStatus: React.FC<IProductStatusListProps> = function ({
  statuses: productStatuses,
  title = 'title',
}) {
  const { text, wrapper } = React.useMemo(() => prdStatus(), []);
  const sortedProductStatuses = sortWithNewProductFirst(productStatuses);

  const renderProductStatuses = sortedProductStatuses.map(product => {
    const id = `product-status - ${title} - ${product.name}`;
    const alertType = product.alert_type.toLowerCase() as AlertLevels;
    return (
      <div
        className={wrapper({
          theme: alertType,
        })}
        key={id}
      >
        <span
          className={text({
            theme: alertType,
          })}
        >
          {product.name}
        </span>
      </div>
    );
  });
  return <div className="pds-flex pds-flex-wrap pds-gap-3">{renderProductStatuses}</div>;
};

export default ProductStatus;
